export default "__VITE_ASSET__NYW1eEO0__"